import { render } from "./InterviewInvite.vue?vue&type=template&id=061ba008"
import script from "./InterviewInvite.vue?vue&type=script&lang=js"
export * from "./InterviewInvite.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__